import { type PingPongLoop, startPingPongLoop } from '@flipster/utils/ping-pong';

import Socket, { SocketPlugin } from './Socket';
import type { MessageEvent } from './r230522/types';

export default class SocketPingPongPlugin implements SocketPlugin {
  #pingPongLoop: PingPongLoop | undefined;

  constructor(
    private socket: Socket,
    private sendRaw: (data: string) => void,
  ) {
    socket.on('connected', () => {
      const abortController = new AbortController();
      socket.once('closed', () => abortController.abort());
      this.#pingPongLoop = startPingPongLoop({
        abortSignal: abortController.signal,
        timeoutMs: 5000,
        waitMs: 2000,
        ping: () => this.sendRaw('ping'),
        timeout: () => {
          // oxlint-disable-next-line no-console
          console.warn('Socket is not responding. Reconnecting...');
          this.socket.reconnect();
        },
      });
    });
  }

  handleRawMessageEvent(messageEvent: MessageEvent, next: (messageEvent: MessageEvent) => void): void {
    const message = messageEvent.data;
    // ping timeout의 의도는 서버에서 메시지가 오고있는지를 확인하는 것이므로
    // pong이 아닌 메시지가 올 때에도 clear timeout 함
    this.#pingPongLoop?.clearTimeout();
    switch (message) {
      case 'pong':
        this.#pingPongLoop?.pong();
        break;
      case 'ping':
        this.sendRaw('pong');
        break;
      default:
        next(messageEvent);
        break;
    }
  }
}
